import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import Nav from '../../lib/Nav';
import BuyerInviteYourTeamLink from '../Links/BuyerInviteYourTeamLink/BuyerInviteYourTeamLink';
import LetUsManageYourProjectLink from '../Links/LetUsManageYourProjectLink/LetUsManageYourProjectLink';
import { LetUsFindFreelancerLink } from '../Links/LetUsFindFreelancerLink';

const ProFeatures: React.FC = () => (
    <>
        <Nav.PopoverItem>
            <Text fontWeight="semibold" as="span">
                <I18n k="header.exclusive_features" />
            </Text>
            <Container
                borderRadius="sm"
                backgroundColor="green_1200"
                width="81px"
                height="20px"
                color="white"
                fontSize="b_sm"
                display="inlineFlex"
                alignItems="center"
                justifyContent="center"
                fontWeight="semibold"
                marginLeft="3"
            >
                <I18n k="header.fiverr_pro" />
            </Container>
        </Nav.PopoverItem>
        <BuyerInviteYourTeamLink showProBadge={false} />
        <LetUsFindFreelancerLink />
        <LetUsManageYourProjectLink />
    </>
);

export default ProFeatures;
